/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Paste_TitleInputs */

const en_editor_paste_title = /** @type {(inputs: Editor_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste as text`)
};

const de_editor_paste_title = /** @type {(inputs: Editor_Paste_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Text einfügen`)
};

/**
* | output |
* | --- |
* | "Paste as text" |
*
* @param {Editor_Paste_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_paste_title = /** @type {((inputs?: Editor_Paste_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Paste_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_paste_title(inputs)
	return en_editor_paste_title(inputs)
});